import { toThemePixels } from '@/utils'
import styled from 'styled-components'
import { Row } from '../../styled'

export const TooltipText = styled(Row)`
  align-items: center;
  gap: ${toThemePixels(1)};
  cursor: pointer;
`
